// extracted by mini-css-extract-plugin
export default {"title":"styles_title__R-7c8","for-members":"styles_for-members__Ewo1j","log-in-text":"styles_log-in-text__4M3sj","login-button":"styles_login-button__TZ5cU"};